<template>
    <div class="search-box clearfix">
        <div class="keyword-input">
            <el-input :placeholder="placeholder ? placeholder : '请输入内容'" v-model="keyword" clearable
                      @keypress.native="e => {if(e.charCode === 13) search();}"
            ></el-input>
        </div>
        <div class="select-box" v-if="select.listData">
            <el-select v-model="select.value" placeholder="请选择">
                <el-option
                        v-for="item in select.listData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="search-btn">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </div>
        <div class="other-btn" v-for="(btn, i) in otherBtns">
            <el-button @click="$emit('click', btn.data)" plain>{{btn.label}}</el-button>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "SearchBox",
        data: () => ({
            keyword: "",
            select: {
                value: "",
                listData: null,
                // [
                //     {
                //         label: "选项1",
                //         value: "1"
                //     }
                // ],
            },
            otherBtns: [
                // {
                //     label: "添加",
                //     data: ""
                // }
            ],
        }),
        props: ["selectData", "btns", "placeholder"],
        mounted: function(){
            if(!obj.isEmpty(this.selectData))
                this.setListData(this.selectData);

            this.otherBtns = obj.isEmpty(this.btns) ? [] : this.btns;
        },
        methods: {
            search: function () {
                let data = {
                    keyword: this.keyword,
                    selectVal: this.select.value
                };
                this.$emit("search", data);
            },
            setListData: function (newData) {
                this.select.value = obj.isEmpty(newData.value) ? "" : newData.value;
                if(obj.isEmpty(newData.listData)){
                    this.select.listData = [];
                }else{
                    newData.listData.unshift({
                        label: "所有",
                        value: ""
                    });
                    this.select.listData = newData.listData;
                }
            }
        },
        watch: {
            "selectData": function (newData) {
                this.setListData(newData);
            },
            "btns": function (newData) {
                this.otherBtns = obj.isEmpty(newData) ? [] : newData;
            }
        }
    }
</script>

<style scoped>
    .search-box{
        height: 72px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        padding: 0px 16px;
    }
    .search-box .keyword-input{
        width: 300px;
    }
    .search-box .select-box{
        margin-left: 10px;
    }
    .search-box .search-btn{
        margin-left: 10px;
    }
    .search-box .other-btn{
        margin-left: 10px;
    }
</style>
